import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "table table-striped table-hover caption-top" }
const _hoisted_2 = { class: "sort-header" }
const _hoisted_3 = { class: "sort-icons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        (_ctx.showIndex)
          ? (_openBlock(), _createElementBlock("th", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('sort')))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", null, _toDisplayString(_ctx.indexLabel), 1),
                _createElementVNode("nav", _hoisted_3, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "sort-up",
                    class: _normalizeClass({ selected: _ctx.sortAsc })
                  }, null, 8, ["class"]),
                  _createVNode(_component_font_awesome_icon, {
                    icon: "sort-down",
                    class: _normalizeClass({ selected: !_ctx.sortAsc })
                  }, null, 8, ["class"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
          return (_openBlock(), _createElementBlock("th", {
            key: col.key
          }, _toDisplayString(col.label), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
            return (_openBlock(), _createElementBlock("td", {
              key: col.key
            }, [
              _renderSlot(_ctx.$slots, col.key, { item: item }, () => [
                _createTextVNode(_toDisplayString(item[col.key]), 1)
              ])
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}